import { defineStore } from "pinia";
import { ref, computed } from "vue";

export interface AuthUser {
    id: number;
    name: string;
    email: string;
    role: string;
    tenant_id: string;
    tenant_name: string;
}

export const useAuthStore = defineStore("auth", () => {
    const token = ref<string | null>(localStorage.getItem("ns_token"));
    const user = ref<AuthUser | null>(
        JSON.parse(localStorage.getItem("ns_user") || "null")
    );

    const isAuthenticated = computed(() => !!token.value);
    const fullName = computed(() => user.value?.name ?? "");
    const tenantName = computed(() => user.value?.tenant_name ?? "");
    const role = computed(() => user.value?.role ?? "");

    function setAuth(newToken: string, newUser: AuthUser) {
        token.value = newToken;
        user.value = newUser;
        localStorage.setItem("ns_token", newToken);
        localStorage.setItem("ns_user", JSON.stringify(newUser));
    }

    function logout() {
        token.value = null;
        user.value = null;
        localStorage.removeItem("ns_token");
        localStorage.removeItem("ns_user");
        // Bersihkan juga sesi mitra hasil impersonate (kalau ada),
        // supaya admin yang logout tidak meninggalkan token mitra menggantung.
        localStorage.removeItem("ns_mitra_token");
        localStorage.removeItem("ns_mitra_user");
    }

    return {
        token,
        user,
        isAuthenticated,
        fullName,
        tenantName,
        role,
        setAuth,
        logout,
    };
});
